import { Box, styled } from '@material-ui/core';

export const Container = styled(Box)({
  flex: 1,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  backgroundColor: '#F8F9FA',
  position: 'relative'
});

export const Header = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  flexDirection: 'column',
  gridGap: 12,
  padding: theme.spacing(3, 4)
}));

export const Group = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gridGap: 10,
  alignSelf: 'flex-end'
});

export const Content = styled(Box)({
  flex: 1,
  overflow: 'auto',
  position: 'relative'
});
